import { createUseStyles } from 'react-jss'
import { mediumGrey } from '../../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  additionalInfo: {
    padding: '0 32px',
    margin: '16px auto 0',
    textAlign: 'center',
    color: mediumGrey
  }
})

export default useStyles
